<template lang="pug">
pr-wrapper(fs, bg, :bgo="preloader ? '1' : '.7'")
  pr-wrapper.d-flex.align-items-center.justify-content-center(fs, bg, zi="1", :class="{ hidden: !preloader }")
    icon.fa-spin.fa-2x(:icon="'fas spinner'")
  layout(v-if="contents.length", :contents="contents", @close="close", background="/v2/assets/images/news/news.jpg", cardWidth="400px")
</template>

<script>
import { mapGetters } from "vuex"
import layout from "./layouts"
export default {
  name: "news",
  components: { layout },
  data() {
    return {
      preloader: true
    }
  },
  computed: {
    contents() {
      return this.news || []
    },
    ...mapGetters("rss", ["news"])
  },
  async activated() {
    this.preloader = true

    await this.$store.dispatch("rss/fetchNews")
    if (!this.contents.length) return this.close()

    await this.$nextTick()
    this.preloader = false
  },
  methods: {
    close() {
      __.platform.go()
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden {
  display: none !important;
}
</style>
